import { useSplitEnabled } from '@buffer-mono/features'

export const COLLABORATION_NOTES_SPLIT = 'geid-collaboration-notes'

/**
 * Split chooses new vs legacy Notes. Legacy Notes owns its entitlement gate.
 * Layout must follow `showPanel`, not the split alone.
 */
export function useCollaborationNotesPanel(): {
  isReady: boolean
  showPanel: boolean
  showLegacyNotes: boolean
} {
  const { isEnabled, isReady } = useSplitEnabled(COLLABORATION_NOTES_SPLIT)

  return {
    isReady,
    showPanel: isReady && isEnabled,
    showLegacyNotes: isReady && !isEnabled,
  }
}
